import { useEffect, useState } from "react";

import { HTTP_STATUS, useApiClient } from "../../api-client";
import { useEmployment } from "../home/useEmployment";

enum CountryIsoCode {
  PORTUGAL = "PT",
  SPAIN = "ES",
  MEXICO = "MX",
}

const useCountryISO2Code = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [countryISO2Code, setCountryISO2Code] = useState<CountryIsoCode>(
    CountryIsoCode.SPAIN
  );
  const { get } = useApiClient();
  const { companyId } = useEmployment();

  const getCountryISO2Code = async () => {
    const { data, status } = await get(`/v1/employee/company/${companyId}`);

    if (status !== HTTP_STATUS.OK) {
      setIsLoading(false);
      return;
    }
    setCountryISO2Code(data.country.ISO2Code);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!companyId) return;
    getCountryISO2Code();
  }, [companyId]);

  return {
    countryISO2Code,
    isLoading,
  };
};

export { useCountryISO2Code, CountryIsoCode };
